import { usePage } from "@inertiajs/react"
import Clarity from "@microsoft/clarity"
import { useEffect } from "react"

import type { SharedData } from "@/types"

const clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_ID as string | undefined

declare global {
  interface Window {
    __clarityInitialized?: boolean
    __clarityProjectId?: string
  }
}

interface ClarityUser {
  uid?: string
  name?: string
}

interface ClarityPageProps extends SharedData {
  gleap_screen?: string | null
}

function initializeClarity(projectId: string) {
  if (window.__clarityInitialized && window.__clarityProjectId === projectId) {
    return
  }

  Clarity.init(projectId)
  window.__clarityInitialized = true
  window.__clarityProjectId = projectId
}

export default function ClarityController() {
  const page = usePage<ClarityPageProps>()
  const authUser = page.props.auth?.user as ClarityUser | undefined

  useEffect(() => {
    if (!clarityProjectId) {
      return
    }

    initializeClarity(clarityProjectId)
  }, [])

  useEffect(() => {
    if (!window.__clarityInitialized) {
      return
    }

    if (authUser?.uid) {
      Clarity.identify(String(authUser.uid), undefined, page.url, authUser.name)
    }

    if (page.props.gleap_screen) {
      Clarity.setTag("screen", page.props.gleap_screen)
    }
  }, [authUser, page.props.gleap_screen, page.url])

  return null
}
